<template>
  <v-app>


    <v-main>
      <router-view/>
    </v-main>



    <!--https://fonts.google.com/icons?selected=Material+Icons -->
 

<v-navigation-drawer class="grey lighten-4"
  v-model="drawer"
  absolute
  bottom
  temporary>
  <v-list nav dense>
    <v-list-item-group
      v-model="group"
      active-class="deep-purple--text text--accent-4"
    >
      <v-list-item @click.stop="$router.push('/sets')">
        <v-list-item-icon>
          <v-icon>mdi-playlist-play</v-icon>
          <span>Sessions</span>
        </v-list-item-icon>    
      </v-list-item>
      <v-list-item @click.stop="$router.push('/list')">
        <v-list-item-icon>
          <v-icon>mdi-playlist-plus</v-icon>
          <span>New session</span>
        </v-list-item-icon>    
      </v-list-item>

      <v-list-item @click.stop="$router.push('/activity')">
        <v-list-item-icon>
          <v-icon>schedule</v-icon>
          <span>Activity</span>
        </v-list-item-icon>   
      </v-list-item>

    <div v-if="signedIn">
      <v-list-item @click="logout()">
        <v-list-item-icon>
          <v-icon>logout</v-icon>
          <span>Sign Out</span>
        </v-list-item-icon>   
      </v-list-item>
      </div>


    </v-list-item-group>
  </v-list>
</v-navigation-drawer>

    <v-snackbar
        v-model="snackbar"
        :timeout=3000
        color="orange"
        centered
        rounded="pill"
        top
      >Please select at least 1 exercise

      </v-snackbar>
  </v-app>

</template>


<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
export default {
name: 'app',
data() {
  return {
    signedIn: false,
    drawer: false,
    group: null,
    snackbar: false
  }
},

  methods: {
    navigateToSession() {
      let setData=this.$store.getters.getCurrentSet;

      if(setData=="") {
        this.snackbar=true;
      }
      else if(setData=="" || setData.exercises.length>0) {
              this.$router.push('session');
      } else {
        this.snackbar=true;
      }

    }
  },
beforeCreate() {
  AmplifyEventBus.$on('authState', info => {
    console.log("beforeCreate");

    if (info === 'signedIn') {
      console.log("signedIn");
      this.signedIn = true
      this.$router.push('/home')
    }
    if (info === 'signedOut') {
      console.log("signedOut");
      this.$router.push('/public')
      //this.$router.go();
      this.signedIn = false
    }
  });




Auth.currentAuthenticatedUser()
      .then(() => this.signedIn = true)
      .catch(() => this.signedIn = false)
      
  },
  created() {
    this.$OneSignal.on('subscriptionChange', function(isSubscribed) {
      console.log("App.vue:: The user's subscription state is now:", isSubscribed);
});
  }

}

</script>


